module.exports = "https://r.nearpod.com/assets/media/image/Flocabulary-03f44628c08979070988143a445d4248.svg";